import {Api} from "../config/request";
const getPurchasedTokens = async (data) => {
    let response = await Api.PostRequest("/getUserPurchasedTokens", data);
    return response.data;
}

const deployTokens = async (data) => {
    let response = await Api.PostMultiPartDataRequest("/deployToken", data);
    return response.data;
}

const deployTokenApi = {
    getPurchasedTokens,
    deployTokens,
}
export default deployTokenApi;